export default "__VITE_ASSET__DVTqP1GP__"